import React, { useState, useEffect, useRef } from "react";
import { isExperienceEditorActive, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import "./index.css";
const LazyLoad = ({
  children,
  tag,
  customClass
}) => {
  const isEditing = isExperienceEditorActive();
  const [intersecting, setIntersecting] = useState(false);
  const elementRef = useRef(null);
  useEffect(() => {
    let observer;
    if (elementRef.current && !isEditing) {
      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0 || entry.isIntersecting) {
              setIntersecting(true);
            }
          });
        }, {
          rootMargin: "0% 0% 0% 0%",
          threshold: 0.01
        });
      } else {
        setIntersecting(true);
      }
      if (observer && elementRef.current) {
        observer.observe(elementRef.current);
      }
    }
    return () => {
      if (observer && observer.unobserve && elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);
  if (isEditing) {
    return /*#__PURE__*/React.createElement("div", {
      ref: elementRef,
      className: `lazy lazy--editable ${customClass ? customClass : ""}`
    }, children);
  }
  if (intersecting) {
    if (tag === "span") {
      return /*#__PURE__*/React.createElement("span", {
        ref: elementRef,
        className: `lazy ${customClass ? customClass : ""} ${intersecting ? "lazy--loaded" : ""}`
      }, children);
    } else {
      return /*#__PURE__*/React.createElement("div", {
        ref: elementRef,
        className: `lazy ${customClass ? customClass : ""} ${intersecting ? "lazy--loaded" : ""}`
      }, children);
    }
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "lazy__placeholder",
    ref: elementRef
  });
};
const LazyLoadWithSitecoreContext = withSitecoreContext()(LazyLoad);
export default LazyLoadWithSitecoreContext;